import { useState } from "react";
import { useTranslation } from "react-i18next";

const FilterCategoryMonitoringMission = ({
  categories,
  selectedCategory,
  setSelectedCategory,
}: any) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="px-3 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200 transition-all duration-200 flex items-center gap-2 min-w-[140px] justify-between"
      >
        <span className="truncate">
          {selectedCategory || t("partner.allCategories")}
        </span>
        <svg 
          className={`w-4 h-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {open && (
        <div className="absolute top-full left-0 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-48 overflow-y-auto">
          <div className="p-1">
            <button
              className="w-full px-3 py-2 text-left text-sm hover:bg-gray-100 rounded-md transition-colors duration-200"
              onClick={() => {
                setSelectedCategory("");
                setOpen(false);
              }}
            >
              Toutes les catégories
            </button>
            {categories?.map((category: any) => (
              <button
                key={category}
                className={`w-full px-3 py-2 text-left text-sm rounded-md transition-colors duration-200 ${
                  selectedCategory === category 
                    ? 'bg-blue-100 text-blue-700' 
                    : 'hover:bg-gray-100'
                }`}
                onClick={() => {
                  setSelectedCategory(category);
                  setOpen(false);
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterCategoryMonitoringMission;
